export default __webpack_public_path__ + "static/media/dulces_detail3.26816aa9.jpg";